/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { blockHeightsGetApiV3BlockHeights } from "../../funcs/blockHeightsGetApiV3BlockHeights.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetApiV3BlockHeightsRequest$inboundSchema.optional(),
};

export const tool$blockHeightsGetApiV3BlockHeights: ToolDefinition<
  typeof args
> = {
  name: "block-heights-get-api-v3-block-heights",
  description: ``,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await blockHeightsGetApiV3BlockHeights(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
